module.exports = __webpack_public_path__ + "static/media/upload.4679dac6.svg";